// extracted by mini-css-extract-plugin
export default {"container":"Elevator_container__eelRc"};